export default {"src":"/_next/static/media/jalapenopeppers.4dbb8696.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};